import { useTranslation } from 'react-i18next';
import { InsetStatCallout } from '../../../components/ui/inset-stat-callout';
import { MediaHero } from '../../../components/ui/media-hero';
import { SPECIES_GATE_HERO } from './speciesGateAssets';

export function SpeciesSelectorHero() {
  const { t } = useTranslation('matching');
  return (
    <MediaHero
      src={SPECIES_GATE_HERO}
      alt={t('species.heroAlt')}
      priority
      footer={
        <InsetStatCallout
          title={t('species.matches')}
          subtitle={t('species.matchesSubtitle')}
        />
      }
    />
  );
}
